/**
 * Adapter from the backend's KpiCell shape (delta as {value, direction})
 * to the frontend KpiStrip's flatter shape (delta as string + `good` flag).
 */
import type { KpiCell as ViewKpiCell } from '../primitives';
import type { KpiCell as ApiKpiCell } from '../regional/regionalApi';

const DIRECTION_TO_GOOD: Record<NonNullable<ApiKpiCell['delta']>['direction'], boolean | null> = {
  up: true,
  down: false,
  flat: null,
};

export function adaptKpis(items: ReadonlyArray<ApiKpiCell>): ViewKpiCell[] {
  return items.map((k) => ({
    label: k.label,
    value: k.value,
    delta: k.delta?.value,
    good: k.delta ? DIRECTION_TO_GOOD[k.delta.direction] : undefined,
  }));
}
